import { Component, inject, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProveedoresService } from '../../service/proveedores/proveedores.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbCalendar, NgbDate, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { from, map, Observable, startWith } from 'rxjs';

@Component({
  selector: 'app-descargar-filtros-dialog',
  //standalone: true,
  //imports: [],
  templateUrl: './descargar-filtros-dialog.component.html',
  styleUrl: './descargar-filtros-dialog.component.scss'
})
export class DescargarFiltrosDialogComponent {

  proveedor
  proveedores = []
  estatusSelected = ''
  estatusForm: FormGroup
  estatusId


  filteredOptions: Observable<string[]>;
  calendar = inject(NgbCalendar);
  formatter = inject(NgbDateParserFormatter);
  hoveredDate: NgbDate | null = null;
  toDate: NgbDate | null = this.calendar.getToday();
  fromDate: NgbDate | null = this.calendar.getPrev(this.calendar.getToday(), 'd', 10);
  displayMonths: number = 1;
  
  constructor( 
      @Inject(MAT_DIALOG_DATA) 
      public data: any,
      private fb: FormBuilder,
      private provedorService: ProveedoresService,
      public dialogRef: MatDialogRef<DescargarFiltrosDialogComponent>) {
        this.estatusForm = this.fb.group({
          estatus: ['', [Validators.required]],
          observacion: ['', [Validators.required]],
          proveedorId: ['', [Validators.required]]
        })
        this.proveedor = data.data
        this.proveedores = data.proveedores
  }

  ngOnInit() {
    this.filteredOptions = this.estatusForm.get('estatus').valueChanges.pipe(
      startWith(''),
      map(value => typeof value === 'string' ? value : value.nombreProveedor),
      map(name => name ? this._filter(name) : this.proveedores.slice())
    );
  }
  private _filter(name: string): any {
    const filterValue = name.toLowerCase();
    return this.proveedores.filter(option => option.nombreProveedor.toLowerCase().includes(filterValue));
  }

  closeDialog() {
    this.dialogRef.close({event: 2});
  }

  save(){
    this.dialogRef.close({event: 1});
  }

  guardarCambios(){
    let claveProv = ''
    this.proveedores.forEach(element => {
      if(element.nombreProveedor === this.estatusForm.get('estatus').value){
        claveProv = element.claveProveedor
      }
    });
    this.dialogRef.close({event: 1, proveedor: claveProv, fechaInicial: this.fromDate, fechaFinal: this.toDate})
  }

  // Metodos para el correcto funcionamiento del picker
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromDate) ||
      (this.toDate && date.equals(this.toDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }


  openPanelOnFocus(event: any): void {

  }

  async cambioInput($event){

  }

  validarDescarga(){

    if(this.toDate !== null && this.fromDate !== null){
      return false
    }else{
      return true
    }
  }
}